import firebase from 'firebase'

var config = {
  apiKey: "AIzaSyAQWAXjkePC9EYL2Qsnmb4LODg6sWIqcQU",
  authDomain: "moviee-b4eb8.firebaseapp.com",
  databaseURL: "https://moviee-b4eb8.firebaseio.com",
  projectId: "moviee-b4eb8",
  storageBucket: "",
  messagingSenderId: "965627065223"
};

firebase.initializeApp(config)
let provider = new firebase.auth.GoogleAuthProvider()
let db = firebase.firestore()

export { firebase, provider, db }